import * as react from "@chakra-ui/react";
import PageTitle from "../components/PageTitle";
import { AddIcon } from "@chakra-ui/icons";
import FileIcon from "../components/icons/FileIcon";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useConnectedUser } from "../hooks/user.hooks";
import { useNewOrderStore } from "../stores/order.store";
import {
	BrandTabButton,
	BrandTabSwitcher,
} from "../components/BrandTabSwitcher";
import { ListIcon, TableIcon } from "lucide-react";
import OrdersTableView from "./orders/layouts/OrdersTableView";
import OrdersKanbanView from "./orders/layouts/OrdersKanbanView";
import { useOrdersKanbanStore } from "../stores/kanban.store";
import { useAdminSettings } from "../hooks/admin_settings.hooks";
import { useSimpleToast } from "../hooks/toast.hooks";

function OrdersPage() {
	const user = useConnectedUser();
	const navigate = useNavigate();
	const { reset } = useNewOrderStore();
	const { tab, setTab } = useOrdersKanbanStore();
	const { data: adminSettings } = useAdminSettings();
	const toast = useSimpleToast();
	const isSuperAdmin = user?.isSuperAdmin === true;
	const effectiveTab = isSuperAdmin ? tab : "table";

	useEffect(() => {
		if (!isSuperAdmin && tab !== "table") {
			setTab("table");
		}
	}, [isSuperAdmin, setTab, tab]);

	return (
		<>
			<react.Flex w="100%" justifyContent="space-between" pb={4}>
				<PageTitle display="inline">Commandes</PageTitle>
				<react.Flex className="flex flex-row items-center gap-2">
					{isSuperAdmin && (
						<BrandTabSwitcher>
							<BrandTabButton
								active={tab === "table"}
								onClick={() => setTab("table")}
							>
								<ListIcon size="16px" />
							</BrandTabButton>
							<BrandTabButton
								active={tab === "kanban"}
								onClick={() => setTab("kanban")}
							>
								<TableIcon size="16px" />
							</BrandTabButton>
						</BrandTabSwitcher>
					)}
					<react.Flex gap={3}>
						{user?.role !== "ADMIN" && (
							<react.Button
								variant="outline"
								onClick={() => {
									if (adminSettings?.disableCommandCreation) {
										toast.error(
											"Commande",
											"La création de commandes est désactivée.",
										);
										return;
									}
									navigate("/orders/supplies");
								}}
							>
								<FileIcon mr={3} />
								Acheter des fournitures
							</react.Button>
						)}
						<react.Button
							bg="brand.700"
							color="white"
							variant="solid"
							onClick={() => {
								if (adminSettings?.disableCommandCreation) {
									toast.error(
										"Commande",
										"La création de commandes est désactivée.",
									);
									return;
								}
								reset();
								navigate("/orders/new");
							}}
						>
							<AddIcon mr={3} /> Créer une commande
						</react.Button>
					</react.Flex>
				</react.Flex>
			</react.Flex>

			{effectiveTab === "table" && <OrdersTableView />}
			{effectiveTab === "kanban" && isSuperAdmin && <OrdersKanbanView />}
		</>
	);
}

export default OrdersPage;
